import { render, staticRenderFns } from "./ExtraOptions.vue?vue&type=template&id=01c1eaf9&scoped=true&"
import script from "./ExtraOptions.vue?vue&type=script&lang=js&"
export * from "./ExtraOptions.vue?vue&type=script&lang=js&"
import style0 from "./ExtraOptions.vue?vue&type=style&index=0&id=01c1eaf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1eaf9",
  null
  
)

export default component.exports